import type { Space } from '@mail/cross-sizes-utils';
import React, { memo } from 'react';
import type { ModeType } from 'reactApp/ui/OverquotaPopup/newSplash/OverquotaSplash.types';
import { formatFileHistoryDate } from 'reactApp/utils/formatDate';

export const Content: React.FC<{ mode?: ModeType; overquota?: Space; clearTime?: number; isMobile?: boolean }> = memo(
    ({ mode, overquota, clearTime, isMobile }) => {
        const br = isMobile ? ' ' : <br />;
        const clearNewMode = mode === 'cleared';

        if (mode === 'cleared') {
            return (
                <>
                    Единое пространство Почты и&nbsp;Облака было переполнено больше 397&nbsp;дней. Спустя этот&nbsp;срок по&nbsp;правилам
                    сервиса оно&nbsp;автоматически очищается
                    {clearNewMode && !!clearTime && <>&nbsp;— после&nbsp;серии уведомлений:</>}
                </>
            );
        }

        if (mode === 'after_clear') {
            return (
                <>
                    Единое пространство Почты и&nbsp;Облака переполнено
                    {overquota?.original ? (
                        <>
                            {' '}
                            на&nbsp;<b>{overquota?.value}</b>
                        </>
                    ) : (
                        ''
                    )}
                    , поэтому&nbsp;по&nbsp;правилам сервиса доступ временно ограничен. Снимите ограничение, и&nbsp;доступ вернётся
                    через&nbsp;несколько дней
                </>
            );
        }

        if (mode === 'blocked') {
            return (
                <>
                    Единое пространство Почты и&nbsp;Облака переполнено
                    {overquota?.original ? (
                        <>
                            {' '}
                            на&nbsp;<b>{overquota?.value}</b>
                        </>
                    ) : (
                        ''
                    )}
                    . Удалите лишнее или увеличьте место с подпиской Mail Space&nbsp;— без этого оно очистится автоматически по правилам
                    сервиса <span>{!!clearTime && formatFileHistoryDate(clearTime)}</span>
                </>
            );
        }

        return (
            <>
                Ваше пространство переполнено
                {overquota?.original ? (
                    <>
                        {' '}
                        на&nbsp;
                        <span>
                            <b>{overquota?.value}</b>
                        </span>
                    </>
                ) : (
                    ''
                )}
                . Удалите&nbsp;лишнее{br}или&nbsp;увеличьте&nbsp;место с&nbsp;подпиской&nbsp;Mail&nbsp;Space — без&nbsp;этого&nbsp;оно
                {br}
                очистится автоматически по правилам сервиса <span>{!!clearTime && formatFileHistoryDate(clearTime)}</span>
            </>
        );
    }
);

Content.displayName = 'Content';
